import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Table } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";

const DebtGoodsDetailsModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.showreceiptmodal);
  const [ReceiptDetails, setReceiptDetails] = useState(
    props.ReceiptDetails.OrderData
  );
  const [GrandTotal, setGrandTotal] = useState(props.ReceiptDetails.Payable);
  // const PCtx = useContext(PermissionContext);

  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);
  // const [NowPaying, setNowPaying] = useState(0);
  // const [PaymentMode, setPaymentMode] = useState("");

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title style={{ color: "brown" }}>
            Items bought by {props.ReceiptDetails.Customer}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Row>
            <Col md={12} sm={12} xs={12}>
              <Row>
                <Col></Col>
                <Col md={12} sm={12} xs={12}>
                  <Table striped bordered responsive>
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Items Description</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ReceiptDetails.map((rct, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{rct.description}</td>
                          <td>{rct.subtotal}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <h5
                    className="text-center"
                    style={{ fontFamily: "Times New Roman" }}
                  >
                    Grand Total: ₦{GrandTotal}
                  </h5>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  );
};

export default DebtGoodsDetailsModal;
